import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, HStack, Text } from '@chakra-ui/react';

import { selectCompany } from '../../../redux/modules/company';
import { selectUser } from '../../../redux/modules/user';
import UserIcon from '../../UserIcon';

const CurrentUser = () => {
  const currentUser = useSelector(selectUser);
  const company = useSelector(selectCompany);

  return (
    <HStack spacing={2}>
      {
        currentUser?.firstName && (
          <UserIcon firstName={currentUser.firstName} iconSize="40px" lastName={currentUser.lastName} />
        )
      }
      <Flex direction="column" textAlign="left">
        <Text mb={0} textStyle="bodyLg600">
          {currentUser.firstName}
          {' '}
          {currentUser.lastName}
        </Text>
        <Text
          color="greyScale.700"
          my={0}
          textStyle="bodySm500"
        >
          {company.companyName}
        </Text>
      </Flex>
    </HStack>
  );
};

export default CurrentUser;
